import React, { forwardRef } from 'react';
import FocusTrap from 'focus-trap-react';

import { StyledDropdownMenu } from './StyledDropdown';
import DropdownMenuItem, { Option } from './DropdownMenuItem';

interface DropdownMenuProps {
  options: Option[];
  selectedOption: Option;
  onSelect: (value: string) => void;
}

const DropdownMenu = forwardRef<HTMLOListElement, DropdownMenuProps>(({
  options,
  selectedOption,
  onSelect,
}, ref) => (
  <FocusTrap focusTrapOptions={{
    allowOutsideClick: true,
    preventScroll: true,
    initialFocus: false,
    fallbackFocus: '#focus-trap-fallback',
  }}>
    <StyledDropdownMenu id="dropdown_menu" ref={ref}>
      {options.map((option) => (
        <DropdownMenuItem
          option={option}
          key={option.value}
          onSelect={() => onSelect(option.value)}
          isSelected={option.value === selectedOption.value}
        />
      ))}
      <li id="focus-trap-fallback" tabIndex={-1} className="hidden" aria-hidden></li>
    </StyledDropdownMenu>
  </FocusTrap>
));

DropdownMenu.displayName = 'DropdownMenu';

export default DropdownMenu;
